<template>
    <div style=" scrollbar-width: thin;" class="w-full h-full bg-[#3a414a] vScore overflow-y-auto ">
        <div class="mt-14 p-4">
            <div class="flex justify-center mb-2 mt-1">
                <InputGroup class="max-w-80">
                    <InputText v-model="searchText" placeholder="Search" id="searchInput" @keydown="clearTimer"
                        @keyup="startTimer"
                        class="text-center rounded-l-md border-2 shadow-none min-w-fit h-6 text-black-900 w-60 border-r-0 bg-white" />
                    <Button icon="pi pi-search"
                        class="bg-[#1f2937] hover:bg-slate-500 text-white font-semi h-6 py-0 px-2 rounded-r" />
                </InputGroup>
            </div>
            <div v-if="!state.isLoading" class="flex">
                <div v-if="searchedData.length !== 0" class=" matchSelect w-full">
                    <div v-for="match in searchedData" :key="match.id"
                        @click="matchSelected(match); router.push('/vscore?q=' + match.id)"
                        class="ml-0.5 mr-0.5 p-4 mt-1 rounded bg-[#1f2937] text-[#dcdde0] items-center flex flex-col hover:border hover:cursor-pointer max-w-[450px] min-w-min float-left">
                        <ul class="w-full ">
                            <!--  -->
                            <!-- <li class="flex justify-between ">
                            <div class="text-center pb-2">
                                <span class="font-bold text-lg text-wrap"> {{ match.name }}</span> -->
                            <!-- <Button type="button" icon="pi pi-info-circle " class="font-semibold w-auto pl-2 text-[#1f2937]" /> -->
                            <!-- @mouseover="toggle($event, player)" -->
                            <!-- </div> -->
                            <!-- <Button icon="pi pi-user-plus text-[#1f2937]"
                                class="bg-[#dcdde0] hover:bg-slate-500 text-[#1f2937] font-semi h-6 py-0 px-2 rounded ml-0.5">
                            </Button> -->
                            <!-- @click="$emit('addPlayer', player); searchResponse.splice(index, 1); if (searchResponse.length == 0) { searchText = ''; searchResponse = undefined; };" -->
                            <!-- </li> -->
                            <li class="text-center font-bold text-lg mb-2">
                                <span> {{ match.team1.team.name }} v {{ match.team2.team.name }}</span>
                            </li>
                            <!-- <li>
                                <span> {{ (new Date(match.startDate)).toUTCString() }} </span>
                            </li>
                            <li>
                                <span> {{ match.venue.name }} </span>
                            </li>
                            <li>
                                <span> {{ match.gender }} </span>
                            </li>
                            <li>
                                <span> {{ match.season }} </span>
                            </li>
                            <li>
                                <span> {{ match.matchType }} </span>
                            </li>
                            <li>
                                <span> {{ match.result }} </span>
                            </li> -->
                            <div class="flex">
                                <div class="flex flex-col w-2/3">
                                    <span> {{ match.venue.name }} </span>
                                    <span> {{ match.venue.city }} | {{ match.venue.country }}</span>
                                    <span v-if="match.series"> {{ match.series.name }} </span>
                                    <span> {{ match.matchType }} </span>
                                    <span> {{ match.season }} </span>
                                    <span> {{ match.gender }} </span>
                                </div>
                                <div class="flex flex-col w-1/3 min-w-min items-end">
                                    <span class=""> {{ new Date(match.startDate).toISOString().split('T')[0] }}
                                    </span>
                                    <span class=""> {{ new Date(match.startDate).toISOString().split('T')[1].slice(0, 5)
                                        }}
                                    </span>

                                    <!-- <span class="">  new Date(match.startDate).toISOString().split('T')[1].slice(0, 5) 
                                    </span> -->
                                    <!-- <i class="pi pi-venus text-[#dcdde0] text-lg w-8 h-8"></i>
                                    <i class="pi pi-plus" style="font-size: 2rem"></i> -->
                                    <!-- <span class="border rounded text-[#dcdde0] text-lg w-8 h-8">
                                        <i class="pi pi-venus text-[#dcdde0] text-lg w-8 h-8"></i>
                                        <i class="pi pi-address-book" style="font-size: 2rem"></i>
                                    </span> -->
                                </div>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-else class="w-full flex pb-10">
                <ProgressSpinner class="justify-center w-90 h-90" attrs-color-black strokeWidth="5"
                    animationDuration="1s" aria-label="Loading" />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, Ref, onMounted } from 'vue'
import { Match } from '@/models/vscoreModels'
import ProgressSpinner from 'primevue/progressspinner'
import { useRealtimeApiStore } from "../store/api/realtimeApi"
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import { useRouter } from 'vue-router'

const router = useRouter()

const api = useRealtimeApiStore();

const state = ref({
    isLoading: true,
    isMatchSelected: false,
})

const data: Ref<Match[]> = ref([])

const selectedMatch: Ref<Match> = ref(<Match>{});

const searchedData: Ref<Match[]> = ref([])
const offset = ref(0)
const limit = ref(50)
const searchText = ref("")
let typingTimer: any;
const typingTime = 200;

onMounted(async () => {
    state.value.isLoading = true

    await api.getAllMatches().then((value) => {
        data.value = value.data;
        createMatchName()
    })

    // for (let index = 0; index < 20; index++) {
    //     data.value.push(data.value[0])
    // }

    searchData()
    state.value.isLoading = false

})

function searchData() {
    searchedData.value = []
    if (searchText.value != '') {
        searchedData.value = data.value.filter((o: any) => o["name"].toUpperCase().includes(searchText.value.toUpperCase())) as []

    } else {
        searchedData.value = data.value as []
    }
    searchedData.value
    return searchedData
}

function matchSelected(match: Match) {
    selectedMatch.value = match;
    state.value.isMatchSelected = true
}

function clearTimer() {
    clearTimeout(typingTimer)
}

function startTimer() {
    clearTimeout(typingTimer)
    offset.value = 0
    typingTimer = setTimeout(searchData, typingTime)
}

function createMatchName() {
    data.value = data.value.map(function (el: any) {
        el.name = (el.team1.team.name + " vs " + el.team2.team.name + " at " + el.venue.name + " on " + (new Date(el.startDate)).toUTCString());
        return el as never;
    })
}

</script>

<style>
.matchSelect {
    display: grid;
    grid-template-rows: auto;
    grid-auto-rows: auto;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 10px;
}

.p-link:focus-visible {
    box-shadow: none;
}

</style>
